// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-data-editor-parent {
    display: flex;
    flex-direction: row-reverse;
    margin: 0;
}

body {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: white;
}
`, "",{"version":3,"sources":["webpack://./packages/table-data-editor/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;AACrB","sourcesContent":[".table-data-editor-parent {\n    display: flex;\n    flex-direction: row-reverse;\n    margin: 0;\n}\n\nbody {\n    width: 100vw;\n    height: 100vh;\n    overflow: hidden;\n    background: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
